export const DashboardRoutes = {
  HOME: "/",
} as const;

export const LogsAuditRoutes = {
  LIST: "/logs-audit",
  DETAILS: "/logs-audit/:id/details",
} as const;

export const ManagerRoutes = {
  LIST: "/manager",
  DETAILS: "/manager/:id/details",
  MANAGER_USER_DETAILS: "/manager/:id/manager-users/:managerUserId/details",
  EDIT: "/manager/:id/edit",
  ADD: "/manager/add",
} as const;

export const UsersRoutes = {
  LIST: "/users",
  DETAILS: "/users/:id/details",
  EDIT: "/users/:id/edit",
  ADD: "/users/add",
} as const;

export const AneelTariffRoutes = {
  LIST: "/aneel-tariffs",
} as const;

export const HelpRoutes = {
  HOME: "/help",
} as const;

export const KnowledgeBaseRoutes = {
  LIST: "/help/knowledge-base",
  ADD: "/help/knowledge-base/add",
  EDIT: "/help/knowledge-base/:id/edit",
} as const;

export const ReleaseNoteRoutes = {
  LIST: "/release-notes",
  ADD: "/release-notes/add",
  EDIT: "/release-notes/:id/edit",
} as const;

export const LeadRoutes = {
  LIST: "/leads",
  DETAILS: "/leads/:id/details",
  EDIT: "/leads/:id/edit",
} as const;
